import React, { useState } from 'react'
import { LuxIcon, Color } from '@lux/wardrobe-lib'
import { Dialog } from 'primereact/dialog'
import { AttachmentProps } from '@/app/models/attachment'
import { DocumentPreviewAdvanced } from './LazyDocumentPreview'
import { b64toBlob } from '@/app/utils/byteArrayToBlob'
import { saveAs } from 'file-saver'
import { ProjectsService } from '@/app/services/ProjectsService'
import './Attachment.scss'

const getAttachmentIcon = (docType) => {
    switch (docType) {
        case 'doc':
        case 'docx':
            return 'file-doc'
        case 'pdf':
            return 'file-pdf'
        case 'xls':
        case 'xlsx':
            return 'file-xls'
        default:
            return 'file'
    }
}

const Attachment = (props: AttachmentProps) => {
    const {
        fileUrl,
        fileBlob,
        fileName,
        fileExtension,
        showDownloadIcon,
        showRemoveIcon,
        hideEyeIcon,
        onRemove,
        onDownloadCallback
    } = props

    const componentClass = 'smart-modals-attachment'

    const [showPreview, setShowPreview] = useState(false)
    const [previewFileUrl, setPreviewFileUrl] = useState(fileUrl)

    const onDownload = () => {
        if (onDownloadCallback) {
            onDownloadCallback()
            return;
        }
        try {
            ;(window as any).webkit.messageHandlers.downloadFromUrl.postMessage({
                url: fileUrl,
                filename: `${fileName}.${fileExtension}`,
                isSplitFile: fileUrl.indexOf('splitfile') > -1,
            })
        } catch (error) {
            const reader = new FileReader()
            reader.onload = function (evt) {
                var splittedB64 = (evt.target.result as any).split(',')[1]
                var blob = b64toBlob(splittedB64, fileBlob.type)
                saveAs(blob, fileBlob.name)
            }
            if (!!fileBlob) {
                reader.readAsDataURL(fileBlob)
            } else {
                if (fileUrl.indexOf('splitfile') > -1) {
                    ProjectsService.SplitToken().then((res) => {
                        fetch(`${fileUrl}?jwt_token=${res.data.jwt_token}`)
                            .then((res) => res.blob())
                            .then((res: any) => {
                                saveAs(new Blob([res]), `${fileName}.${fileExtension}`)
                            })
                    })
                } else {
                    fetch(fileUrl)
                        .then((res) => res.blob())
                        .then((res: any) => {
                            saveAs(new Blob([res]), `${fileName}.${fileExtension}`)
                        })
                }
            }
        }
    }

    const onPreview = () => {
        if (fileUrl.indexOf('splitfile') > -1) {
            ProjectsService.SplitToken().then((res) => {
                setPreviewFileUrl(`${fileUrl}?jwt_token=${res.data.jwt_token}`)
                setShowPreview((value) => !value)
            })
        } else {
            setPreviewFileUrl(fileUrl)
            setShowPreview((value) => !value)
        }
    }

    return (
        <div className={componentClass}>
            {!!showPreview && (
                <Dialog
                    header={fileName}
                    visible={!!showPreview}
                    onHide={() => setShowPreview(false)}
                    style={{ width: '80vw', height: '100%' }}>
                    <DocumentPreviewAdvanced
                        header={null}
                        fileUrl={previewFileUrl}
                        fileName={fileName}
                        className={'attachment-preview'}
                    />
                </Dialog>
            )}
            <div className={`${componentClass}__attachment-item`}>
                <div className={`${componentClass}__file-container`}>
                    <LuxIcon icon={getAttachmentIcon(fileExtension)} color={Color.BLUE} />
                    <span className="link">{fileName}</span>
                </div>
                <div className={`${componentClass}__icon-container`}>
                    {showDownloadIcon && (
                        <div className={`${componentClass}__icon`} onClick={onDownload}>
                            <LuxIcon icon="download" color={Color.BLUE} />
                        </div>
                    )}
                    {!hideEyeIcon && (
                        <div className={`${componentClass}__icon`} onClick={(e) => onPreview()}>
                            <LuxIcon icon="eye" color={Color.BLUE} />
                        </div>
                    )}
                    {showRemoveIcon && (
                        <div className={`${componentClass}__icon`} onClick={(e) => onRemove()}>
                            <LuxIcon icon="trash" color={Color.BLUE} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Attachment
